<template>
  <span class="bg-tag px-1 py-0.5 rounded text-sm">
    <slot/>
  </span>
</template>
